import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gh-logo',
    templateUrl: 'logo.component.html',
    standalone: false
})

export class LogoComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}